import React, { useState, useEffect } from 'react';
import './GraphicalSlider.css';
import GraphicalIcon from '../GraphicalIcon/GraphicalIcon';
import RangeInput from '../RangeInput/RangeInput';
import validate from '../../common/validate';
import logComponent from '../../common/logComponent';

export default function GraphicalSlider({ initialValue, showError, errorMessage, rules, onValidate, name, items, minRange, maxRange,  label}) {
  const [nativeInputValue, setNativeInputValue] = useState(initialValue > 0 && +initialValue <= 10 ? +initialValue : 1);
  const [selectedValue, setSelectedValue] = useState(+initialValue > 0 && +initialValue <= 10 ? +initialValue : null);
  const [validationDetails, setValidationDetails] = useState(null);
  const [isValid, setIsValid] = useState(null);
  const [needsValidate, setNeedsValidate] = useState(false);
  const [hasLabels, setHasLabels] = useState(items.filter(item => item.key).length > 0);

  if (logComponent('GraphicalSlider')) { console.debug('GraphicalSlider render'); }

  useEffect(() => {
    if (logComponent('GraphicalSlider')) { console.debug('GraphicalSlider onMount'); }
    validateThis();
  }, [])

  useEffect(() => {
    if (logComponent('GraphicalSlider')) { console.debug('GraphicalSlider useEffect [needsValidate]'); }
    if (needsValidate === true) {
      validateThis();
      setNeedsValidate(false);
    }
  }, [needsValidate])

  const validateThis = () => {
    if (logComponent('GraphicalSlider')) { console.debug('GraphicalSlider validateThis'); }

    let validationDetailsThis = [];
    for (let rule in rules) {
      validationDetailsThis.push({
        rule: rule,
        valid: validate[rule](selectedValue, rules[rule])
      })
    }
  
    let isValidThis = validationDetailsThis.reduce((prev, curr) => prev && curr.valid, true);

    setValidationDetails(validationDetailsThis);
    setIsValid(isValidThis);

    onValidate({
      name: name,
      isValid: isValidThis,
      value: selectedValue
    });
  }

  const updateSelectedValue = (newValue) => {
    if (logComponent('GraphicalSlider')) { console.debug('GraphicalSlider updateSelectedGraphical'); }
    setSelectedValue(newValue);
    setNeedsValidate(true);
  }

  return (
    <div className="Graphical-Slider">
      {
        showError && !isValid &&
        <p className="Graphical-Slider__error">{errorMessage}</p>
      }
      <h4 className="Graphical-Slider__heading">
        {label}
        {
          rules && rules.required &&
          <span className="Graphical-Slider__required"> *</span>
        }
      </h4>
      <div className="Graphical-Slider__body">
        <div className="Graphical-Slider__slider">
          <RangeInput
            min={minRange}
            max={maxRange}
            startAtNull={selectedValue === null}
            initial={nativeInputValue}
            onChange={updateSelectedValue}
            onBlur={validateThis}
            showNumbers={true}
            showLabels={hasLabels}
            showGraphics={true}
            items={items}
            alwaysShowOptions={true}
          />
        </div>
      </div>
    </div>
  );
}